import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { isLoggedIn, isAdmin } from './helpers/helpers_general.js';

import Login from './views/login.js';
import Register from './views/register.js';
import SendTokenPassword from './views/SendTokenPassword.js';
import RecoverPassword from './views/RecoverPassword.js';
import RecoverPasswordWithoutToken from './views/RecoverPasswordWithoutToken.js';
import Home from './views/Home.js';
import HomeView from './views/HomeView.js';
import ContentList from './views/ContentList.js';
import Profile from './views/profile.js';
import UserList from './views/UserList.js';
import SearchView from './views/SearchView.js';

const Main = () => {
  return (
    <Switch>
      <Route exact path="/" component={Login}></Route>
      <Route exact path="/register" component={Register}></Route>
      <Route exact path="/send_token_password" component={SendTokenPassword}></Route>
      <Route exact path="/recover_password" component={RecoverPassword}></Route>
      <Route
        exact
        path="/recover_password_without_token"
        component={RecoverPasswordWithoutToken}
      ></Route>
      <Route exact path="/home" component={isLoggedIn() ? HomeView : Login}></Route>
      <Route exact path="/category" component={isLoggedIn() ? Home : Login}></Route>
      <Route
        exact
        path="/search/:search"
        component={isLoggedIn() ? SearchView : Login}
      ></Route>
      <Route
        exact
        path="/category/:categoryId"
        component={isLoggedIn() ? ContentList : Login}
      ></Route>
      <Route exact path="/profile/:id" component={Profile}></Route>
      <Route exact path="/user" component={isAdmin() ? UserList : Login}></Route>
      <Route exact path="/logs" component={isLoggedIn() ? Home : Login}></Route>
    </Switch>
  );
};

export default Main;
